import { Lightbulb } from "lucide-react";

type SafetyFactProps = {
  fact: string;
};

export function SafetyFact({ fact }: SafetyFactProps) {
  return (
    <div className="flex gap-3 rounded-xl border border-sky-100 bg-sky-50 px-4 py-3.5">
      <Lightbulb className="mt-0.5 h-4 w-4 flex-shrink-0 text-sky-500" />
      <p className="text-sm leading-relaxed text-gray-600">
        <span className="font-semibold text-sky-700">Czy wiesz, że… </span>
        {fact}
      </p>
    </div>
  );
}
